<template>
  <wrap ref="wrapRef">
    <div class="receive-coupons">
      <div class="receive-coupons__banner" v-if="activeData.img">
        <img :src="activeData.img" />
      </div>
      <div
        class="receive-coupons__btn end"
        v-if="[4, 5, 6].includes(activeData.activityStatus)"
      >
        活动已结束
      </div>
      <template v-else>
        <div
          class="receive-coupons__btn"
          @click="getcoupons"
          v-if="activeData.receiveStatus == 0"
        >
          立即领取
        </div>
        <div class="receive-coupons__btn gosub" @click="toSub" v-else>去订阅</div>
      </template>
      <div class="receive-coupons__rule">
        <div class="rule-title">活动规则</div>
        <div class="rule-item" v-for="(item, index) in activeData.rules" :key="index">
          {{ item }}
        </div>
      </div>
      <img
        class="receive-coupons__bottom"
        src="https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/subscription-udp/%E7%BC%96%E7%BB%84%204%402x%20%281%29.png"
      />
    </div>
  </wrap>
</template>
<script setup>
import { ref, computed, onMounted, watch } from "vue";
import wrap from "./components/wrap.vue";
import { useRoute } from "vue-router";
import { getPrivateActivity, getWXUrlCoupon } from "@/api/udp";
import { Toast } from "vant";
onMounted(() => {
  init();
});
const route = useRoute();
const wrapRef = ref(null);
const activeData = ref({
  title: "",
  img: "",
  rules: [],
});
const init = () => {
  getPrivateActivity({
    eventActivityId: route.query.aid,
    vipId: route.query["c_userid"],
  }).then((res) => {
    if (res.status === 200 && res.data.code === "0") {
      activeData.value = {
        title: res.data.body.eventActivityName,
        img: res.data.body.headImage,
        rules: res.data.body.eventActivityDescription?.split("\n") || [],
        /** activityStatus枚举
          CREATE(0, "新建"),
          OPENING(1, "启用中"),
          OPEN(2, "已启用"),
          COMPILE(3, "进行中"),
          TERMINATE(4, "已终止"),
          CLOSING(5, "已结束"),
          TERMINATING(6, "终止中");
        */
        activityStatus: res.data.body.activityStatus,
        /** receiveStatus枚举
          0-没领取
          1-领取
         */
        receiveStatus: res.data.body.receiveStatus,
      };
    } else {
      Toast((res.data && res.data.msg) || "查询失败");
    }
  });
};
watch(activeData, () => {
  const titleDom = document.querySelector("title");
  if (titleDom && activeData.value.title) {
    titleDom.innerHTML = activeData.value.title;
  }
});
const toSub = () => {
  wrapRef.value?.toSub();
};
const toLogin = () => {
  wrapRef.value?.toLogin();
};
const isLogin = computed(() => !!route.query["c_userid"]);
// 点击领取
let getCouponsing = false;
const getcoupons = () => {
  if (getCouponsing) return;
  getCouponsing = true;
  if (isLogin.value) {
    getWXUrlCoupon({
      eventActivityId: route.query.aid,
      vipId: route.query["c_userid"],
    })
      .then((res) => {
        if (res.status === 200 && res.data.code === "0") {
          Toast("领取成功");
          init();
        } else {
          Toast((res.data && res.data.msg) || "领取失败");
        }
      })
      .finally(() => {
        getCouponsing = false;
      });
  } else {
    toLogin();
    getCouponsing = false;
  }
};
</script>
<style lang="scss" scoped>
.receive-coupons {
  width: 100%;
  background-color: #f7f7f7;
}
.receive-coupons__banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.receive-coupons__rule {
  margin: 65px 50px 70px;
  background-color: #fff;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
}
.rule-title {
  font-size: 28px;
  line-height: 44px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  font-weight: 600;
  text-align: center;
  padding: 50px 0 12px;
  &::after,
  &::before {
    content: "]";
    display: inline-block;
    padding: 0 8px;
    color: #ff5841;
  }
  &::before {
    content: "[";
  }
}
.rule-item {
  font-weight: 400;
  font-size: 26px;
  color: #595959;
  line-height: 45px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  padding: 27px 43px 25px 79px;
  position: relative;
  background: url("https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/subscription-udp/%E7%BC%96%E7%BB%84%202%402x%20%288%29.png")
    43px 44px / 16px 12px no-repeat;
  & + .rule-item {
    &::after {
      content: "";
      position: absolute;
      right: 43px;
      top: 0;
      display: block;
      width: 528px;
      height: 0;
      border-top: 2px dashed #d4d4d4;
    }
  }
}
.receive-coupons__bottom {
  display: block;
  margin: 0 auto 88px;
  width: 453px;
}
.receive-coupons__btn {
  display: block;
  margin: 60px auto;
  width: 570px;
  height: 80px;
  background: linear-gradient(90deg, #65696b 0%, #24292b 100%);
  border-radius: 4px;
  font-weight: normal;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
  text-align: center;
  font-style: normal;
  &.end {
    background: #e4e4e4;
    color: #8e8e8e;
  }
  &.gosub {
    background: rgba(0, 0, 0, 0);
    border: 1px solid #8e9091;
    color: #24292b;
  }
}
</style>
